import { useDimensions } from "src/utils/useDimensions.js";
import CenterDialog from "./CenterDialog.js";
import BottomDialog from "./BottomDialog.js";

/**
 * Bottom tray on mobile, centered card on desktop — the shared version of the
 * `isSmallScreen ? BottomDialog : CenterDialog` pattern. Common props
 * (`open`, `handleClose`, `children`, `sx`, `hideCloseButton`, `data-testid`, …)
 * pass to whichever renders; variant-only props go via `bottomProps`
 * (e.g. `hideRectangle`) / `centerProps` (e.g. `maxWidth`, `fullWidth`).
 */
export default function ResponsiveDialog({
  bottomProps = {},
  centerProps = {},
  ...props
}) {
  const { isSmallScreen } = useDimensions();
  return isSmallScreen ? (
    <BottomDialog {...props} {...bottomProps} />
  ) : (
    <CenterDialog {...props} {...centerProps} />
  );
}
